import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { SystemDataSequenceId } from "./systemDataSequenceTypes";

export interface DataSequenceBase extends DocEntityBase<"DATA_SEQUENCE"> {
  readonly id: PrimaryEntityId<"DATA_SEQUENCE">;
}

export interface CustomDataSequence extends DataSequenceBase {
  readonly sequenceType: "CUSTOM";
  readonly cols: { readonly id: string; readonly name: string; readonly type: "TEXT" | "NUMBER" | "SYMBOL" }[];
  readonly rows: { readonly [id: string]: string | number }[];
}

export const CUSTOM_SHEET_DATA_SEQUENCE_COLUMNS: CustomDataSequence["cols"] = [
  {
    id: "name",
    name: "Name",
    type: "TEXT",
  },
  {
    id: "number",
    name: "Number",
    type: "TEXT",
  },
];

export interface SystemDataSequence extends DataSequenceBase {
  readonly sequenceType: "SYSTEM";
  readonly source: SystemDataSequenceId;
}

export type DataSequence = CustomDataSequence | SystemDataSequence;
